const IconCheckboxNo = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <rect width="20" height="20" rx="5" fill="#25354d" opacity="0.096"/>
    </svg>
}

export default IconCheckboxNo;
